import { Injectable, inject } from "@angular/core";
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpHeaders,
	HttpStatusCode
} from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";
import { Store } from "@ngrx/store";
import { AuthState, NoHttpAuthAction } from "../store";
import { Router } from "@angular/router";

@Injectable({
	providedIn: "root"
})
export class HttpRequestInterceptor implements HttpInterceptor {
	private store = inject<Store<AuthState>>(Store);
	private config = inject<AppConfig>(APP_CONFIG_TOKEN);
	private router = inject(Router);

	/**
	 * intercept all XHR request
	 * @param request
	 * @param next
	 * @returns {Observable<HttpEvent<any>>}
	 */
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// build additional headers
		const headers = new HttpHeaders({
			// 'Authorization': 'token 123',
			"Client-Version": this.config.version,
			"Client-Name": this.config.app
		});

		// clone the request and add new headers
		const clonedRequest = request.clone({ headers });

		return next.handle(clonedRequest).pipe(
			catchError((error, _caught) => {
				// intercept the response error
				console.error(`HttpRequestInterceptor catched error: ${error.status}`, error, request);

				// let the SignInComponent and the ca-viewer ViewComponent handle an 'unauthorized' error response by itself
				if (
					error.status === HttpStatusCode.Unauthorized &&
					(request.url.endsWith("/customer") || request.url.endsWith("/admin") || request.url.endsWith("/viewer"))
				) {
					return throwError(() => error);
				}

				if (error.status === HttpStatusCode.Unauthorized) {
					// redirect to signin page if an unauthorized error occurs apart of a failed login in SignInComponent or the ca-viewer ViewComponent
					this.store.dispatch(new NoHttpAuthAction());
					return of(error);
				}

				// handle version mismatch between client and server
				if (error.status === HttpStatusCode.ImATeapot) {
					window.location.reload();
					return of(null);
				}

				// handle bad gateway error (502) with redirect to error page (e.g. if server is not responding)
				if (error.status === HttpStatusCode.BadGateway) {
					this.router.navigate(["/error"]);
					return of(error);
				}

				return throwError(() => error);
			})
		);
	}
}
